<template>
    <div class="page product-page-typography">
        <section class="intro">
            <div class="container">
                <div class="grid4-img">
                    <ResponsiveImg
                        class="grid4-img__image intro__image"
                        imgClass="img__bitrix-telegram img__bitrix-whatsapp--1"
                        path="bitrix-instagram"
                        name="main"
                        alt="Instagram in Bitrix24, Umnico Widget"
                        :isNotLazy="true"
                        htmlWidth="620"
                        htmlHeight="515"
                        fetchpriority="high"
                    />
                    <div class="grid4-img__head intro__head">
                        <h1
                            class="intro__header intro__header heading-primary red-i"
                            v-html="$t(`__bitrix_instagram_main_title`)"
                        />
                    </div>
                    <div class="grid4-img__text intro__text">
                        <p class="paragraph-primary">
                            {{ $t('__bitrix_instagram_main_description_1') }}
                        </p>
                        <p class="paragraph-primary">
                            {{ $t('__bitrix_instagram_main_description_2') }}
                        </p>
                    </div>
                    <div class="grid4-img__btn intro__btn">
                        <div class="intro__buttons">
                            <router-link
                                :to="ROUTES.REGISTER"
                                class="brand-button brand-button--red"
                            >
                                {{ $t('__bitrix_instagram_button_try_free') }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="interactive">
            <div class="container">
                <Advantages
                    :list="advantagesList"
                    :isSwitchableDescription="true"
                />
            </div>
        </section>

        <section class="page__block">
            <BlockClientsGrey
                :center="true"
                :list="['sber', 'kia', 'invitro', 'dhl', 'raif']"
            />
        </section>

        <section class="container">
            <BlueBoxWithText
                :title="aboutList.title"
                :texts="aboutList.texts"
            />
        </section>

        <section class="about-problem">
            <div class="container">
                <div class="about-problem__inner">
                    <h3 class="about-problem__title heading-tertiary">
                        {{ $t('__bitrix_instagram_problem_solution_title') }}
                    </h3>
                    <Advantages
                        :list="problemsList"
                        :isSwitchableDescription="false"
                        headerClass="about-problem__header"
                    />
                </div>
            </div>
        </section>

        <section>
            <Quiz :title="$t(`__bitrix_instagram_quiz_title`)" />
        </section>

        <section class="outlined-block">
            <div class="container">
                <div class="outlined-block__inner">
                    <h2
                        class="outlined-block__title heading-secondary red-i"
                        v-html="$t('__bitrix_instagram_customer_requests_title')"
                    />

                    <p class="outlined-block__text paragraph-primary">
                        {{ $t('__bitrix_instagram_customer_requests_text_1') }}
                    </p>
                    <p class="outlined-block__text paragraph-primary">
                        {{ $t('__bitrix_instagram_customer_requests_text_2') }}
                    </p>

                    <img
                        class="outlined-block__corner-img"
                        :src="instagramTransparentIcon"
                        alt="Instagram icon"
                        width="125"
                        height="125"
                    />
                </div>
            </div>
        </section>

        <section class="opportunities page__block">
            <div class="container opportunities__indent">
                <h2
                    class="opportunities__title heading-secondary red-i"
                    v-html="$t(`__bitrix_instagram_opportunities_title`)"
                />
                <p
                    class="opportunities__text paragraph-primary"
                    v-html="$t('__bitrix_instagram_opportunities_text')"
                ></p>
            </div>

            <BlockInteg2Side
                class="two-side two-side-gaps"
                :header="$t('__bitrix_instagram_connect_title')"
                :plist="[$t('__bitrix_instagram_connect_text_1'), $t('__bitrix_instagram_connect_text_2')]"
                path="bitrix-instagram"
                image="instagram-1"
                imgClass="img__bitrix-instagram img__bitrix-instagram--picture-1"
                :reverse="true"
                width="460"
                height="345"
                alt="Connect any number of Instagram accounts to Bitrix24 with Umnico"
            />

            <BlockInteg2Side
                class="two-side two-side-gaps two-side__right"
                :header="$t('__bitrix_instagram_send_title')"
                :plist="[$t('__bitrix_instagram_send_text_1'), $t('__bitrix_instagram_send_text_2')]"
                path="bitrix-instagram"
                image="instagram-2"
                imgClass="img__bitrix-instagram img__bitrix-instagram--picture-2"
                :reverse="false"
                width="430"
                height="405"
                alt="Umnico - one widget to process all inquiries in Bitrix24"
            />

            <BlockInteg2Side
                class="two-side two-side-gaps"
                :header="$t('__bitrix_instagram_reply_title')"
                :plist="[$t('__bitrix_instagram_reply_text_1'), $t('__bitrix_instagram_reply_text_2')]"
                path="bitrix-instagram"
                image="instagram-3"
                imgClass="img__bitrix-instagram img__bitrix-instagram--picture-3"
                :reverse="true"
                width="460"
                height="351"
                alt="Response to mentionings in Stories and comments in your posts with Bitrix24"
            />

            <div class="crms-cta--small block-mb">
                <div class="container">
                    <div class="crms-cta__container">
                        <div class="crms-cta__inner">
                            <div class="crms-cta__body">
                                <div class="crms-cta__img">
                                    <img
                                        class="crms-cta__amo_whatsapp-icon"
                                        :src="instagramBigIcon"
                                        alt="Telegram logo"
                                    />
                                </div>
                                <div class="crms-cta__text">
                                    <p class="crms-cta__title heading-tertiary">
                                        {{ $t('__bitrix_instagram_banner_title') }}
                                    </p>
                                    <p class="crms-cta__description paragraph-primary">
                                        {{ $t('__bitrix_instagram_banner_text') }}
                                    </p>
                                </div>
                                <div class="crms-cta__button">
                                    <router-link
                                        class="crms-cta__link brand-button brand-button--red"
                                        :to="ROUTES.REGISTER"
                                    >
                                        {{ $t('__bitrix_instagram_button_try_free') }}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <BlockInteg2Side
                class="two-side two-side-gaps two-side__right"
                :header="$t('__bitrix_instagram_automatic_title')"
                :plist="[$t('__bitrix_instagram_automatic_text_1'), $t('__bitrix_instagram_automatic_text_2')]"
                path="bitrix-instagram"
                image="instagram-4"
                imgClass="img__bitrix-instagram img__bitrix-instagram--picture-4"
                :reverse="false"
                width="376"
                height="370"
                alt="An automatic welcome message to greet new clients with Bitrix24"
            />

            <BlockInteg2Side
                class="two-side two-side-gaps"
                :header="$t('__bitrix_instagram_expand_title')"
                :plist="[$t('__bitrix_instagram_expand_text_1'), $t('__bitrix_instagram_expand_text_2')]"
                path="bitrix-instagram"
                image="instagram-5"
                imgClass="img__bitrix-instagram img__bitrix-instagram--picture-5"
                :reverse="true"
                width="430"
                height="340"
                alt="Supervise your staff and monitor communication performance in Bitrix24"
            />

            <BlockInteg2Side
                class="two-side two-side__right two-side-last"
                imgClass="img__bitrix-whatsapp two-side__image-inner"
                :header="$t('__bitrix_instagram_engage_title')"
                :plist="[$t('__bitrix_instagram_engage_text_1'), $t('__bitrix_instagram_engage_text_2')]"
                path="bitrix-instagram"
                image="instagram-6"
                :reverse="false"
                width="460"
                height="355"
                :alt="
                    lang === 'ru'
                        ? 'Chat with a customer through Instagram Direct in Bitrix24 with no VPN '
                        : 'Bitrix24 app and Instagram integration by Umnico to chat with clients on the go'
                "
            />
        </section>

        <div class="advantages-grid advantages--is-main">
            <div class="container">
                <div class="advantages-grid__container">
                    <div class="advantages-grid__item item-blue item-a">
                        <h2>
                            {{ $t('__bitrix_instagram_grid_item_1') }}
                        </h2>
                    </div>
                    <div class="advantages-grid__item item-b">
                        <div
                            class="advantages-grid__item-title"
                            v-html="$t('__bitrix_instagram_grid_item_2')"
                        />

                        <ResponsiveImg
                            class="item-b__img"
                            alt="Chat to deal switching"
                            path="amocrm-whatsapp"
                            name="amocrm-whatsapp-11"
                            htmlHeight="97"
                            htmlWidth="203"
                        />
                    </div>
                    <div class="advantages-grid__item item-blue item-c">
                        <div
                            class="advantages-grid__item-title item-c__title"
                            v-html="$t('__bitrix_instagram_grid_item_3')"
                        />

                        <ResponsiveImg
                            class="item-c__img"
                            alt="Filters and block lists"
                            path="bitrix-instagram"
                            name="instagram-7"
                            htmlHeight="190"
                            htmlWidth="230"
                        />
                    </div>
                    <div class="advantages-grid__item item-d">
                        <div
                            class="advantages-grid__item-title"
                            v-html="$t('__bitrix_instagram_grid_item_4')"
                        />

                        <div class="advantages-grid__item-bottom">
                            <ResponsiveImg
                                alt="Message citation"
                                path="bitrix-instagram"
                                name="instagram-8"
                                htmlHeight="151"
                                htmlWidth="213"
                            />
                        </div>
                    </div>
                    <div class="advantages-grid__item item-blue item-e">
                        <div
                            class="advantages-grid__item-title"
                            v-html="$t('__bitrix_instagram_grid_item_5')"
                        />

                        <div class="advantages-grid__item-bottom img-inner-shadow">
                            <ResponsiveImg
                                path="bitrix-instagram"
                                name="instagram-9"
                                alt="Application settings"
                                htmlHeight="215"
                                htmlWidth="462"
                            />
                        </div>
                    </div>
                    <div class="advantages-grid__item item-blue item-f">
                        <div
                            class="advantages-grid__item-title item-f__title"
                            v-html="$t('__bitrix_instagram_grid_item_6')"
                        />
                        <ResponsiveImg
                            imgClass="item-f__img"
                            alt="Cross-channel reply"
                            path="bitrix-instagram"
                            name="instagram-10"
                            htmlHeight="164"
                            htmlWidth="302"
                        />
                    </div>
                    <div class="advantages-grid__item item-blue item-g">
                        <div
                            class="advantages-grid__item-title"
                            v-html="$t('__bitrix_instagram_grid_item_7')"
                        />

                        <div class="advantages-grid__item-bottom item-g__container">
                            <img
                                class="item-g__img"
                                :src="quickSearch"
                                alt="Message search"
                            />
                        </div>
                    </div>
                    <div class="advantages-grid__item item-h">
                        <div
                            class="advantages-grid__item-title"
                            v-html="$t('__bitrix_instagram_grid_item_8')"
                        />

                        <ResponsiveImg
                            imgClass="item-f__img"
                            alt="Chat access management"
                            path="bitrix-instagram"
                            name="instagram-11"
                            htmlHeight="154"
                            htmlWidth="301"
                        />
                    </div>
                </div>
            </div>
        </div>

        <section class="amo-whatsapp-table">
            <div class="container">
                <h2 class="amo-whatsapp-table__title heading-secondary">
                    {{ $t('__bitrix_instagram_table_title') }}
                </h2>
                <p class="amo-whatsapp-table__text paragraph-primary">
                    {{ $t('__bitrix_instagram_table_text') }}
                </p>
                <Table
                    theme="rounded"
                    :tableData="btWaTable"
                />
            </div>
        </section>

        <HowConnectStep
            class="how-connect page__block custom-link"
            :title="howConnect.title"
            :isSlotUsed="true"
            :videoPlayer="videoLink"
        >
            <template
                v-if="lang === 'ru' || lang === 'en'"
                #step1
            >
                <router-link :to="ROUTES.REGISTER">{{ $t('__bitrix_instagram_how_connect_step_1_link') }}</router-link>
                {{ $t('__bitrix_instagram_how_connect_step_1') }}
            </template>

            <template
                v-else
                #step1
            >
                <router-link :to="ROUTES.REGISTER">{{ $t('__bitrix_instagram_how_connect_step_1_link') }}</router-link>
            </template>
            <template #step2>
                {{ $t('__bitrix_instagram_how_connect_step_2') }}
            </template>
            <template #step3>
                {{ $t('__bitrix_instagram_how_connect_step_3_1') }}
                <a
                    :href="appLink"
                    target="_blank"
                >
                    {{ $t('__bitrix_instagram_how_connect_step_3_link') }}
                </a>
                {{ $t('__bitrix_instagram_how_connect_step_3_2') }}
            </template>

            <template #text>
                {{ $t('__bitrix_instagram_how_connect_text_1') }}
                <router-link :to="ROUTES.HELP_CENTER_CRM_B24_INSTAGRAM">{{
                    $t('__bitrix_instagram_how_connect_text_link')
                }}</router-link>
                {{ $t('__bitrix_instagram_how_connect_text_2') }}
            </template>
        </HowConnectStep>

        <BlockDevelopRate
            :header="i18n('__bitrix_instagram_rate_title')"
            :headDesc="i18n(`__bitrix_instagram_rate_subtitle`)"
            :subHeader="$t('__common_price_sentence_variant_4', price)"
            :desc="i18n('__bitrix_instagram_rate_description')"
            :btnTextRate="i18n('__bitrix_instagram_rate_button_1')"
            :btnTry="i18n('__bitrix_instagram_button_try_free')"
            :noShadow="true"
            btnClasses1="brand-button brand-button--red-outline"
            btnClasses2="brand-button brand-button--red"
        />

        <section class="about-integrations">
            <div class="container">
                <div class="about-integrations__inner">
                    <h2 class="about-integrations__title heading-secondary">
                        {{ $t('__bitrix_instagram_integrations_title') }}
                    </h2>
                    <p class="about-integrations__text paragraph-primary">
                        {{ $t('__bitrix_instagram_integrations_text') }}
                    </p>
                    <Advantages
                        :list="integrationsList"
                        :isSwitchableDescription="false"
                        :headerAsLink="true"
                        headerClass="about-integrations__header"
                        descriptionClass="about-integrations__description"
                    />
                </div>
            </div>
        </section>

        <FAQ
            class="page__block faq-padding faq"
            :title="$t('__bitrix_instagram_faq_header')"
            :description="$t('__bitrix_instagram_faq_description')"
            :items="faqList"
            color="#FE1B51"
        />

        <section v-if="lang === 'ru'">
            <div class="container">
                <p class="disclaimer">
                    {{ $t('__integration_disclaimer') }}
                </p>
            </div>
        </section>

        <CTARegistration
            bgColor="#001933"
            pseudoColor="#1C92FF"
            :title="CTARegestationList.title"
            :texts="[lang !== 'de' ? $t('__bitrix_instagram_cta_registration_text') : '']"
            :button="CTARegestationList.button"
        />
    </div>
</template>

<script>
import ROUTES from '../../../router/routing';
import ModalManager, { ModalName } from '../../../utils/modal-manager';

import Advantages from '../../../components/Advantages';
import BlockClientsGrey from '../../../components/BlockClientsGrey';
import BlockDevelopRate from '../../../components/BlockDevelopRate';
import BlockInteg2Side from '../../../components/BlockInteg2Side';
import BlueBoxWithText from '../../../components/BlueBoxWithText';
import FAQ from '../../../components/FAQ';
import CTARegistration from '../../../components/CTARegistration';
import ResponsiveImg from '../../../components/ResponsiveImg';
import HowConnectStep from '../../../components/HowConnectStep2';
import Table from '../../../components/Table';
import Quiz from '../../../components/Quiz';
import getPageLang from '../../../utils/getPageLang';

import tickMark from '../../../assets/svg/stickers/check-mark.svg';
import linkBlueIco from '../../../assets/svg/stickers/link-blue.svg';
import messageBlastingGreenIco from '../../../assets/svg/stickers/message-blasting-green.svg';
import eyeRed from '../../../assets/svg/stickers/eye-red.svg';
import replyGreen from '../../../assets/svg/stickers/reply-green.svg';
import chatBlue from '../../../assets/svg/stickers/chat.svg';
import instagramTransparentIcon from '../../../assets/svg/stickers/instagram-transparent.svg';

import whatsappIcon from '../../../assets/svg/apps/whatsapp-mini.svg';
import instagramBigIcon from '../../../assets/svg/apps/instagram-mini.svg';
import telegramIcon from '../../../assets/svg/apps/telegram-mini.svg';
import vkIcon from '../../../assets/svg/apps/vk-mini.svg';
import avitoIcon from '../../../assets/svg/apps/avito-mini.svg';

import chatIcon from '../../../assets/svg/bitrix-whatsapp/chat.svg';
import dealIcon from '../../../assets/svg/bitrix-whatsapp/deal.svg';
import messengers from '../../../assets/svg/advantages/massengers.png';
import quickSearch from '../../../assets/svg/advantages-grid/quick-search.png';

import getVideo from '../../../utils/getVideo';

export default {
    name: 'IntegrationsBi',
    components: {
        Quiz,
        Table,
        ResponsiveImg,
        Advantages,
        BlockClientsGrey,
        CTARegistration,
        BlockDevelopRate,
        BlockInteg2Side,
        BlueBoxWithText,
        FAQ,
        HowConnectStep,
    },
    data() {
        return {
            instagramBigIcon,
            chatIcon,
            dealIcon,
            messengers,
            messageBlastingGreenIco,
            quickSearch,
            replyGreen,
            eyeRed,
            instagramTransparentIcon,
            lang: getPageLang(),

            aboutList: {
                title: this.$t('__bitrix_instagram_why_title'),
                texts: [this.$t('__bitrix_instagram_why_text_1'), this.$t('__bitrix_instagram_why_text_2')],
            },

            advantagesList: [
                {
                    header: this.$t('__bitrix_instagram_advantage_icon_1'),
                    description: this.$t('__bitrix_instagram_advantages_description_1'),
                    icon: replyGreen,
                    alt: 'Reply',
                    width: 40,
                    height: 40,
                },
                {
                    header: this.$t('__bitrix_instagram_advantage_icon_2'),
                    description: this.$t('__bitrix_instagram_advantages_description_2'),
                    icon: chatBlue,
                    alt: 'Chats',
                    width: 40,
                    height: 40,
                },
                {
                    header: this.$t('__bitrix_instagram_advantage_icon_3'),
                    description: this.$t('__bitrix_instagram_advantages_description_3'),
                    icon: eyeRed,
                    alt: 'Monitoring',
                    width: 40,
                    height: 40,
                },
            ],

            problemsList: [
                {
                    header: this.$t('__bitrix_instagram_problem_solution_title_1'),
                    description: this.$t('__bitrix_instagram_problem_solution_text_1'),
                    icon: tickMark,
                    alt: 'Check mark',
                },
                {
                    header: this.$t('__bitrix_instagram_problem_solution_title_2'),
                    description: this.$t('__bitrix_instagram_problem_solution_text_2'),
                    icon: tickMark,
                    alt: 'Check mark',
                },
                {
                    header: this.$t('__bitrix_instagram_problem_solution_title_3'),
                    description: this.$t('__bitrix_instagram_problem_solution_text_3'),
                    icon: tickMark,
                    alt: 'Check mark',
                },
                {
                    header: this.$t('__bitrix_instagram_problem_solution_title_4'),
                    description: this.$t('__bitrix_instagram_problem_solution_text_4'),
                    icon: tickMark,
                    alt: 'Check mark',
                },
                {
                    header: this.$t('__bitrix_instagram_problem_solution_title_5'),
                    description: this.$t('__bitrix_instagram_problem_solution_text_5'),
                    icon: tickMark,
                    alt: 'Check mark',
                },
                {
                    header: this.$t('__bitrix_instagram_problem_solution_title_6'),
                    description: this.$t('__bitrix_instagram_problem_solution_text_6'),
                    icon: tickMark,
                    alt: 'Check mark',
                },
            ],

            btWaTable: [
                {
                    '': this.$t('__bitrix_instagram_table_row_1'),
                    [this.$t(
                        '__bitrix_instagram_table_column_1'
                    )]: `<span class="table-circle table-circle--red">-</span>`,
                    [this.$t('__bitrix_instagram_table_column_2')]: `<span class="table-circle">+</span>`,
                },
                {
                    '': this.$t('__bitrix_instagram_table_row_2'),
                    [this.$t(
                        '__bitrix_instagram_table_column_1'
                    )]: `<span class="table-circle table-circle--red">-</span>`,
                    [this.$t('__bitrix_instagram_table_column_2')]: `<span class="table-circle">+</span>`,
                },
                {
                    '': this.$t('__bitrix_instagram_table_row_3'),
                    [this.$t(
                        '__bitrix_instagram_table_column_1'
                    )]: `<span class="table-circle table-circle--red">-</span>`,
                    [this.$t('__bitrix_instagram_table_column_2')]: `<span class="table-circle">+</span>`,
                },
                {
                    '': this.$t('__bitrix_instagram_table_row_4'),
                    [this.$t(
                        '__bitrix_instagram_table_column_1'
                    )]: `<span class="table-circle table-circle--red">-</span>`,
                    [this.$t('__bitrix_instagram_table_column_2')]: `<span class="table-circle">+</span>`,
                },
                {
                    '': this.$t('__bitrix_instagram_table_row_5'),
                    [this.$t(
                        '__bitrix_instagram_table_column_1'
                    )]: `<span class="table-circle table-circle--red">-</span>`,
                    [this.$t('__bitrix_instagram_table_column_2')]: `<span class="table-circle">+</span>`,
                },
                {
                    '': this.$t('__bitrix_instagram_table_row_6'),
                    [this.$t(
                        '__bitrix_instagram_table_column_1'
                    )]: `<span class="table-circle table-circle--red">-</span>`,
                    [this.$t('__bitrix_instagram_table_column_2')]: `<span class="table-circle">+</span>`,
                },
                {
                    '': this.$t('__bitrix_instagram_table_row_7'),
                    [this.$t(
                        '__bitrix_instagram_table_column_1'
                    )]: `<span class="table-circle table-circle--red">-</span>`,
                    [this.$t('__bitrix_instagram_table_column_2')]: `<span class="table-circle">+</span>`,
                },
            ],

            howConnect: {
                title: this.$t('__bitrix_instagram_how_connect_title'),
            },

            integrationsList: [
                {
                    header: this.$t('__bitrix_instagram_integrations_item_1_title'),
                    description: this.$t('__bitrix_instagram_integrations_item_1_text'),
                    icon: whatsappIcon,
                    alt: 'Whatsapp',
                    internalLink: ROUTES.INTEGRATIONS_BW,
                },
                {
                    header: this.$t('__bitrix_instagram_integrations_item_2_title'),
                    description: this.$t('__bitrix_instagram_integrations_item_2_text'),
                    icon: telegramIcon,
                    alt: 'Instagram',
                    internalLink: ROUTES.INTEGRATIONS_BT,
                },
                {
                    header: this.$t('__bitrix_instagram_integrations_item_3_title'),
                    description: this.$t('__bitrix_instagram_integrations_item_3_text'),
                    icon: vkIcon,
                    alt: 'Vk',
                    internalLink: ROUTES.INTEGRATIONS_BV,
                },
                {
                    header: this.$t('__bitrix_instagram_integrations_item_4_title'),
                    description: this.$t('__bitrix_instagram_integrations_item_4_text'),
                    icon: avitoIcon,
                    alt: 'Avito',
                    internalLink: ROUTES.HELP_CENTER_CRM_B24_AVITO,
                },
            ],

            faqList: [
                {
                    title: this.$t('__bitrix_instagram_faq_title_1'),
                    value: this.$t('__bitrix_instagram_faq_text_1'),
                },
                {
                    title: this.$t('__bitrix_instagram_faq_title_2'),
                    value: this.$t('__bitrix_instagram_faq_text_2'),
                },
                {
                    title: this.$t('__bitrix_instagram_faq_title_3'),
                    value: this.$t('__bitrix_instagram_faq_text_3'),
                },
                {
                    title: this.$t('__bitrix_instagram_faq_title_4'),
                    value: this.$t('__bitrix_instagram_faq_text_4'),
                },
                {
                    title: this.$t('__bitrix_instagram_faq_title_5'),
                    value: this.$t('__bitrix_instagram_faq_text_5'),
                },
                {
                    title: this.$t('__bitrix_instagram_faq_title_6'),
                    value: this.$t('__bitrix_instagram_faq_text_6'),
                },
                {
                    title: this.$t('__bitrix_instagram_faq_title_7'),
                    value: this.$t('__bitrix_instagram_faq_text_7'),
                },
                {
                    title: this.$t('__bitrix_instagram_faq_title_8'),
                    value: this.$t('__bitrix_instagram_faq_text_8'),
                },
                {
                    title: this.$t('__bitrix_instagram_faq_title_9'),
                    value: this.$t('__bitrix_instagram_faq_text_9'),
                },
                {
                    title: this.$t('__bitrix_instagram_faq_title_10'),
                    value: this.$t('__bitrix_instagram_faq_text_10'),
                },
            ],

            CTARegestationList: {
                title: this.$t('__bitrix_instagram_cta_registration_title'),
                button: this.$t('__common.nav.register'),
            },

            ROUTES,
            linkBlueIco,
            videoLink: getVideo('bitrix'),
        };
    },
    computed: {
        price() {
            return this.$store.getters.getPriceByName('bitrixInstagram');
        },
        appLink() {
            switch (this.lang) {
                case 'ru':
                    return 'https://www.bitrix24.ru/apps/app/umnico.app/';
                case 'es':
                    return 'https://www.bitrix24.es/apps/app/Umnico.worldwide/';
                case 'de':
                    return 'https://www.bitrix24.de/apps/app/Umnico.worldwide/';
                case 'en':
                    return 'https://www.bitrix24.com/apps/app/Umnico.worldwide/';
                default:
                    return 'https://www.bitrix24.com/apps/app/Umnico.worldwide/';
            }
        },
    },
    methods: {
        openPopup() {
            ModalManager.open(ModalName.DEMONSTRATION);
        },
    },
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
